// extracted by mini-css-extract-plugin
export default {"errorMsg":"form-error_errorMsg__hEovK"};